import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import EditIcon from '@components/Icon/Edit'

class AtheneumOfficeTable extends Component {
  static propTypes = {
    modalStore: PropTypes.object,
    atheneumOfficeStore: PropTypes.object
  }

  renderRows = () => {
    const { atheneumOfficeStore, modalStore } = this.props
    const { atheneumOffices } = atheneumOfficeStore
    const officeRows = atheneumOffices.map(office => {
      return (
        <tr key={office.id}>
          <td>{office.name}</td>
          <td>{office.entityName}</td>
          <td
            className='right clickable'
            onClick={() => {
              modalStore.show({
                type: 'ATHENEUM_OFFICE_FORM',
                props: {
                  atheneumOffice: office,
                  atheneumOfficeStore,
                  wideContent: true
                }
              })
            }}
          >
            <EditIcon />
          </td>
        </tr>
      )
    })

    return <tbody>{officeRows}</tbody>
  }

  render () {
    return (
      <table className='table-wrapper'>
        <thead>
          <tr>
            <th>
              <h2>Companies</h2>
            </th>
          </tr>
          <tr>
            <th>Name</th>
            <th>Entity name</th>
            <th className='right'>Actions</th>
            <th className='half-width' />
          </tr>
        </thead>
        {this.renderRows()}
      </table>
    )
  }
}

export default inject('modalStore')(observer(AtheneumOfficeTable))
